import React from 'react';
import { makeStyles } from '@rbx/ui';
import { engineRevampMonospaceTextStyle } from '@modules/ui/shared/utils/styles';

const useSpaceSuffixedColonStyles = makeStyles()((theme) => {
  return {
    spaceSuffixedColonWrapper: {
      display: 'inline-block',
      fontWeight: 500,
      color: theme.palette.content.muted,
      marginRight: '4px',
    },
    spaceSuffixedColonWrapperRevamp: {
      ...engineRevampMonospaceTextStyle,
      display: 'inline-block',
      color: theme.palette.content.muted,
      marginRight: '4px',
    },
  };
});

interface SpaceSuffixedColonProps {
  engineRevampEnabled?: boolean;
}

const SpaceSuffixedColon = ({ engineRevampEnabled = false }: SpaceSuffixedColonProps) => {
  const { classes } = useSpaceSuffixedColonStyles();
  const className = engineRevampEnabled
    ? classes.spaceSuffixedColonWrapperRevamp
    : classes.spaceSuffixedColonWrapper;
  return <span className={className}>:</span>;
};

export default SpaceSuffixedColon;
